import { createAction } from "redux-actions";
import { AccountConstants } from "./accountConstants";

export const fetchAccounts = createAction(AccountConstants.FETCH_ACCOUNTS);
export const fetchRoles = createAction(AccountConstants.FETCH_ROLES);
